var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReached && _vm.threshold !== null)?_c('div',{staticClass:"reservationRestTimeWrapper"},[_c('div',[_c('b-icon-clock'),_vm._v(" 現在選択中の日時は"+_vm._s(_vm.thresholdFormat)+"までに予約を完了する必要があります。急いで予約を完了するか、別の日時での予約をご検討ください。")],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }